define('viewModels/privileged/qm/PlaybackView',[
    'lib/knockout',
    'lib/lodash4',
    'lib/bluebird',
    'jquery',
    'services/authService',
    'services/loggingService',
    'services/navHelper',
    'services/notificationService',
    'services/toastService',
    'services/qualityManagementService',
    'services/userService',
    'services/callService',
    'services/toastService',
    'services/qm/qualityAuth',
    'services/apiCore',
    'services/featureToggleService',
    'util/errorCallbackFactory',
    'viewModels/privileged/composer/forms/EmbeddedQualityFormEditor',
    'viewModels/privileged/qm/ConversationDetailsView',
    'viewModels/privileged/qm/CalibrationResultsView',
    'viewModels/privileged/qm/QualitySummaryView',
    'viewModels/privileged/qm/CustomerJourneyView',
    'viewModels/privileged/qm/EvaluationView',
    'viewModels/privileged/qm/CreateEvaluationView',
    'viewModels/privileged/qm/AuditView',
    'viewModels/privileged/qm/RecordingManagerView',
    'viewModels/widgets/TabbedContentView',
    'viewModels/ViewModel',
    'viewModels/privileged/qm/ConversationTimelineView',
    'viewModels/privileged/qm/util/BroadCastEnum',
    'services/qm/qualityBroadcast',
    'models/composer/forms/FormType',
    'util/FeatureToggleDisabledError',
    'util/InsufficientPermissionsError',
    'util/MissingJourneyContextError'
], function (ko,
             _,
             Bluebird,
             $,
             authService,
             LOG,
             navHelper,
             notificationService,
             toasts,
             qualityManagementService,
             userService,
             callService,
             toastService,
             qualityAuthorization,
             apiCore,
             featureToggleService,
             errorCallbackFactory,
             EmbeddedQualityFormEditor,
             ConversationDetailsView,
             CalibrationResultsView,
             QualitySummaryView,
             CustomerJourneyView,
             EvaluationViewWrapper,
             CreateEvaluationView,
             AuditView,
             RecordingManagerView,
             TabbedContentView,
             ViewModel,
             ConversationTimelineView,
             BroadcastEnum,
             qualityBroadcast,
             FormType,
             FeatureToggleDisabledError,
             InsufficientPermissionsError,
             MissingJourneyContextError
) {
    'use strict';

    var PlaybackView = ViewModel.extend(function (conversationId, options) {
        var self = this;
        var CUSTOMER_JOURNEY_PERMISSIONS = [
            'perm:journey:customer:view',
            'perm:journey:segment:view',
            'perm:journey:outcome:view',
            'perm:journey:visit:view',
            'perm:journey:event:view'
        ];

        self.conversationId = ko.observable(conversationId);
        self.emailMessage = ko.observable();
        self.tabbedDetails = self.subView(TabbedContentView);
        self.tabbedDetails.conversationId(self.conversationId());
        self.conversation = ko.observable();
        self.conversationDetailsV6 = ko.observable();
        self.evaluations = ko.observableArray();
        self.surveys = ko.observableArray();
        self.calibrations = ko.observableArray();
        self.journeyContexts = ko.observableArray();
        self.isConversationLoading = ko.observable(true);
        self.isEvaluationsLoading = ko.observable(true);
        self.isCalibrationsLoading = ko.observable(true);
        self.isEvaluationSummaryLoading = ko.observable(true);
        self.hasParticipantToEvaluate = ko.observable(true);
        self.newEvalHref = '#admin/interactions/' + self.conversationId() + '/evaluations/new';
        self.isAgent = authService.principalId() && authService.hasAnyAuthorization(['perm:routing:agent:onqueue']);
        self.qualityEvaluator = authService.principalId() && authService.hasAnyAuthorization(['qualityEvaluator']);
        self.qualityAdmin = authService.principalId() && authService.hasAnyAuthorization(['qualityAdmin']);
        self.isCallTerminatedMessage = ko.observable();
        self.canEditEvaluationOrScore = qualityAuthorization.canEditEvaluation() || qualityAuthorization.canEditScore();
        // TODO: abstract away journey permissions checking (service?)
        self.canViewConversationCustomerJourney = authService.hasAuthorization({ all: CUSTOMER_JOURNEY_PERMISSIONS }, true /* ignoreDivisions */ );
        self.playbackContext = ko.observable();
        self.needsWrapup = ko.observable(false);
        self.acdVoicemailIds = ko.observable();
        self.isCurrentUserOnConversation = ko.observable(false);

        var coachingFeatureToggleKeys = [
            'coaching.usability.ui',
            'coaching.status.prevent-agent',
            'coaching.usability.add-to-existing',
            'coaching.overdue.ui',
            'coaching.wizard.tabs',
            'coaching.usability.notes'
        ];

        self.coachingFeatureToggles = ko.observableArray(
            featureToggleService.getFeatureTogglesArray(coachingFeatureToggleKeys)
        );


        var hashContextPattern = /#(.*)\/interactions/i;
        var getHashContext = function () {
            var currentHash = window.location.hash;
            var matches = hashContextPattern.exec(currentHash);
            if (matches && matches.length > 1) {
                return matches[1];
            }
            else {
                LOG.error("Couldn't detect a hash context.");
            }
        };

        /**
         *  ACTIVE CALL
         * @type {*}
         */
        self.isActiveCall = self.computed(function () {
            // Call is not active if it has an endTime.
            // Also added a hack to go ahead and show the recording if it
            // exists. This can happen for stuck calls.
            return self.conversation() &&
                !self.conversation().hasOwnProperty('endTime') &&
                !self.recordingManagerView.hasRecordings();
        });

        var recordingManagerOptions = _.extend({}, options, {
            isActive: self.isActiveCall
        });

        var acdVoicemailInfo = {
            acdVoicemailIds: self.acdVoicemailIds,
            isCurrentUserOnConversation: self.isCurrentUserOnConversation
        };

        self.recordingManagerView = self.subView(RecordingManagerView, self.conversationId, acdVoicemailInfo, recordingManagerOptions);

        self.displayWrapupView = self.computed(function() {
            return self.needsWrapup() &&
                !self.recordingManagerView.hasRecordings() &&
                !self.isActiveCall();
        });

        self.hasConnectedCallback = self.computed(function () {
            if (self.conversation()) {
                var participants = self.conversation().participants();
                return _.some(participants, function (participant) {
                    return participant.callbacks &&
                           participant.callbacks.length > 0 &&
                           _.some(participant.callbacks, function (callback) {
                                return _.some(callback.segments, function (segment) {
                                    return !segment.endTime;
                                });
                           });
                });
            }
            return false;
        });

        var conversationDetailsOptions = {
            recordingInformation: self.recordingManagerView.recordingInformation,
            keywordSpots: self.recordingManagerView.keywordSpots
        };

        self.conversationDetailsView = self.subView(ConversationDetailsView, self.conversation, self.conversationDetailsV6, conversationDetailsOptions);
        self.conversationTimelineView = self.subView(ConversationTimelineView, self.conversationDetailsV6);
        self.internalParticipantViews = self.conversationDetailsView.internalParticipantViews;
        self.externalParticipantViews = self.conversationDetailsView.externalParticipantViews;

        if (options && options.playbackContext){
            self.playbackContext(options.playbackContext);
        }

        var checkInternalParticipant = function (participants) {
            return !!_.find(participants(), function (participant) {
                if (participant.purpose) {
                    return participant.purpose.toLowerCase() === 'user' || participant.purpose.toLowerCase() === 'agent';
                }

                if (participant.participantType) {
                    return participant.participantType.toLowerCase() === 'internal';
                }
                return false;
            });
        };


        var CUSTOMER_JOURNEY_PROPS = [
            'journeyCustomerId',
            'journeyCustomerIdType',
            'journeyCustomerSessionId',
            'journeyCustomerSessionIdType'
        ];
        /**
         * predicate, determines if a session has a journeyContext
         *
         * @param  {object} session
         */
        var sessionHasAllCustomerJourneyProps = function(session) {
            if (session) {
                return _.reduce(CUSTOMER_JOURNEY_PROPS, function (acc, curr) {
                    return acc && session.hasOwnProperty(curr);
                }, true);
            }
            return false;
        };

        /**
         * gets journey contexts from a participants sessions
         *
         * @param    {object} participant
         * @returns  {(array | undefined)}
         */
        var getParticipantJourneyContexts = function (participant) {
            if (participant) {
                return _.map(participant.sessions, function (session) {
                    if (sessionHasAllCustomerJourneyProps(session)) {
                        return _.assign(
                            _.pick(participant, ['participantName']),
                            _.pick(session, ['mediaType']),
                            _.pick(session, CUSTOMER_JOURNEY_PROPS)
                        );
                    }
                    return undefined;
                });
            }
        };

        /**
         * gets the a journeyContext from an array of conversation participants
         *
         * @param    {object} conversationDetailsV6
         * @returns  {(object | undefined)}
         */
        var getConversationCustomerParticipantJourneyContexts = function(conversationDetailsV6) {
            return _(conversationDetailsV6.participants)
                .filter(['purpose', 'customer'])
                .flatMap(getParticipantJourneyContexts)
                .compact()
                .value();
        };

        var checkIfNeedsWrapup = function(participants){
            return !!_.find(participants(), function(participant){
                return participant.wrapupRequired && !participant.wrapup;
            });
        };

        var getAcdVoicemailIds = function(conversation) {
            var callbacks = _.compact(_.flatMap(conversation.participants(), 'callbacks'));
            var sortedCallbacks = _.sortBy(callbacks, ['connectedTime']);
            var voicemailIds = _.compact(_.map(sortedCallbacks, function (callback) {
                return callback.voicemail ? callback.voicemail.id : null;
            }));
            return _.uniq(voicemailIds);
        };

        /**
         * Adds the timeline tab to the conversation page, then loads the template, along with the appropriate view
         * Adds the conversation timeline tab to the conversation page, then loads the template, along with the appropriate view
         * It also adds the css along with the label to the Timeline Tab
         * @returns void
         */
        var addTimelineTab = function (conversationId) {
            if (!self.tabbedDetails.containsTab('timeline')){
                var tabContentViews = {};
                tabContentViews.timeline = {
                    view: function () { return self.conversationTimelineView; },
                    template: "templates/appMain/privilegedMain/qm/timelineView",
                    persist: true
                };
                var context = self.canEditEvaluationOrScore ? "admin" : "agent";
                var tabMenuItems = getTabMenuItems(context, conversationId, "timeline", 'timeline');
                self.tabbedDetails.addTabViews(tabMenuItems, tabContentViews);
            }
        };

        var getConversation = function() {
            self.isConversationLoading(true);
            qualityManagementService.getConversation(self.conversationId())
                .then(self.conversation)
                .then(function(){
                    self.tabbedDetails.participants(self.conversation().participants);
                    self.tabbedDetails.isActive(self.conversationDetailsView.active);
                    addTimelineTab(self.conversationId());
                    self.recordingManagerView.setConversation(self.conversation);
                    self.tabbedDetails.coachingFeatureToggles(self.coachingFeatureToggles());
                })
                .catch(errorCallbackFactory.createCallback({ namespace: "playback.conversationRequest"}))
                .finally(function () {
                    self.isConversationLoading(false);
                });
        };
        getConversation();

        var getConversationDetailsV6 = function() {
            self.conversationDetailsV6(null);
            apiCore.v2.get('/analytics/conversations/' + self.conversationId() + '/details')
                .then(self.conversationDetailsV6)
                .then(function() {
                    self.journeyContexts(getConversationCustomerParticipantJourneyContexts(self.conversationDetailsV6()));
                });
        };
        getConversationDetailsV6();

        var getEvaluations = function() {

            var userType = getHashContext() === "admin" ? "evaluator" : "agent";

            var evaluationOptions = {
                agentId: userService.currentUser().id,
                conversationId: self.conversationId(),
                userType: userType
            };

            if (userType === "agent") {
                evaluationOptions.isReleased =  true;
                evaluationOptions.evaluationState = [qualityManagementService.FINISHED];
            }

            qualityManagementService.getAssignedEvaluations(evaluationOptions)
                .then(function(response){
                    self.evaluations(response);
                })
                .catch(function (error) {
                    var httpStatus = error.type === "http" ? error.details.status : undefined;
                    if(!(httpStatus && httpStatus === 401)) {
                        errorCallbackFactory.createCallback({namespace: "playback.evaluationsRequest"})(error);
                    }
                })
                .finally(function () {
                    self.isEvaluationsLoading(false);
                });
        };
        getEvaluations();

        var getCalibrations = function() {
            if (userService.currentUser()) {
                if (qualityAuthorization.canViewCalibration()) {
                    qualityManagementService.getCalibrations({'conversationId': self.conversationId(), 'calibratorId': userService.currentUser().id})
                        .then(self.calibrations)
                        .catch(errorCallbackFactory.createCallback({ namespace: "playback.calibrationsRequest"}))
                        .finally(function () {
                            self.isCalibrationsLoading(false);
                        });
                }
            }
        };
        getCalibrations();

        var ACTIVECONVERSATIONPOLL_SECONDS = 5;
        var activeConversationUpdateInterval;
        self.computed(function () {
            clearInterval(activeConversationUpdateInterval);
            if (self.conversationDetailsView.active()) {
                var conversationUpdateCounter = 0;
                activeConversationUpdateInterval = setInterval(function () {
                    var detailsView = self.conversationDetailsView;
                    var timelineView = self.conversationTimelineView;
                    if (detailsView.active.peek() || timelineView.active.peek() || self.hasConnectedCallback()) {
                        if (timelineView.updateLiveSegments) {
                            timelineView.updateLiveSegments();
                        }

                        if (detailsView.updateDuration) {
                            detailsView.updateDuration();
                        }

                        if (++conversationUpdateCounter >= ACTIVECONVERSATIONPOLL_SECONDS) {
                            conversationUpdateCounter = 0;
                            getConversation();
                            getConversationDetailsV6();
                        }
                    }
                }, 1000);
            }
        });

        function getTabMenuItems(context, conversationId, endpoint, labelItem){
            return [{
                hash: '#' + context + '/interactions/' + conversationId + '/' + endpoint,
                label: 'playback.nav.' + labelItem,
                cssClass: "nav-item-transient"
            }];
        }

        /**
         * TAB CONTROL
         * @param conversationId
         */
        var addConversationTab = function (conversationId) {
        if (!self.tabbedDetails.containsTab('conversationDetailsView')) {
                var tabMenuItems;
                var tabContentViews = {
                    "conversationDetailsView": {
                        view: function () { return self.conversationDetailsView; },
                        template: "templates/appMain/privilegedMain/qm/conversationDetails",
                        persist: true
                    }
                };

                if(self.canEditEvaluationOrScore){
                    tabMenuItems = [{
                        hash: '#admin/interactions/' + conversationId,
                        label: 'playback.nav.conversationDetails',
                        matchExactly: true
                    }];
                } else {
                    tabMenuItems = [{
                        hash: "#agent/interactions/" +conversationId,
                        label: 'playback.nav.conversationDetails',
                        matchExactly: true
                    }];
                }

                self.tabbedDetails.addTabViews(tabMenuItems, tabContentViews);
            }
        };

        var activateTabIfNeeded = function(/*tabKey, additionalArgs*/) {

            var tabName = arguments[0];

            // Workaround for (intentional) behavior change in SwitchView where a subview
            // flagged as persistent will get disposed anyway if it is activated
            // when it is already active.
            if (self.tabbedDetails.currentViewData()) {
                var activeTabName = self.tabbedDetails.currentViewData().viewKey;
                if (activeTabName === tabName) {
                    return self.tabbedDetails.currentViewData();
                }
            }

            return self.tabbedDetails.setActiveTabView.apply(self.tabbedDetails, arguments);
        };

        self.activateConversationDetailsTab = function () {
            addConversationTab(self.conversationId());
            activateTabIfNeeded('conversationDetailsView');
        };

        var createCalibrationCallback = function(newCalibration) {
            self.tabbedDetails.removeActiveTabView();
            var destination = '#admin/interactions/' + self.conversationId() + '/calibrations/' + newCalibration.id;
            navHelper.navigateTo(destination);
        };
        var cancelCreateEvaluationCallback = function() {
            self.tabbedDetails.removeActiveTabView();
        };
        var newEvaluationCallback = function(newEvaluation) {
            var destination;
            if(newEvaluation) {
                self.tabbedDetails.removeActiveTabView();
                if(newEvaluation.evaluator.id === authService.principalId()) {
                    destination = '#admin/interactions/' + self.conversationId() + '/evaluations/' + newEvaluation.id;
                    navHelper.navigateTo(destination);
                } else {
                    var notificationTitle = 'playback.nav.evaluation.created';
                    var notificationMsg = 'playback.nav.evaluation.created.for';
                    var selectedEvaluatorName = ko.unwrap(newEvaluation.evaluator.name);
                        toasts.notifyMessage(notificationTitle, {
                        bodyMessageKey: notificationMsg,
                        messageData: { evaluatorName : selectedEvaluatorName },
                        icon: "pc-icon-messages"
                    });
                    destination = '#admin/interactions/' + self.conversationId() + '/qualitySummary';
                    navHelper.navigateTo(destination);
                }
            }
        };

        self.activateCreateEvaluationTab = function () {
            if(qualityAuthorization.canAddEvaluation()) {
                if (!self.tabbedDetails.containsTab('new')) {
                    var tabContentViews = {};
                    tabContentViews['new'] = {
                        view: CreateEvaluationView,
                        template: "templates/appMain/privilegedMain/qm/createEvaluation",
                        arguments: [ self.conversation, newEvaluationCallback, cancelCreateEvaluationCallback, createCalibrationCallback ],
                        persist: true
                    };
                    var tabMenuItems = getTabMenuItems("admin", self.conversationId(), 'evaluations/new', 'newEvaluation');
                    self.tabbedDetails.addTabViews(tabMenuItems, tabContentViews);
                    self.tabbedDetails.setActiveTabView("new", self.conversation, newEvaluationCallback, cancelCreateEvaluationCallback, createCalibrationCallback);
                } else {
                    self.tabbedDetails.setActiveTabView("new", self.conversation);
                }
            }
        };

        var deleteEvaluationCallback = function(conversationId, assignedEvaluationId) {
            if(qualityAuthorization.canDeleteEvaluation()) {
                return qualityManagementService.deleteEvaluation(conversationId, assignedEvaluationId)
                    .then(function() {
                        var currentViewData = self.tabbedDetails.currentViewData();
                        if (currentViewData && (currentViewData.viewKey === assignedEvaluationId)) {
                            self.tabbedDetails.removeActiveTabView();
                        } else {
                            removeEvaluationTab("admin", assignedEvaluationId);
                        }

                        toasts.notifyMessage('playback.nav.evaluation.deleted.title', {
                            bodyMessageKey: 'playback.nav.evaluation.deleted.msg'
                        });
                    })
                    .catch(function() {
                        toasts.notifyMinorAlert('playback.nav.evaluation.not.deleted.title', {
                            bodyMessageKey: 'playback.nav.evaluation.not.deleted.msg'
                        });
                    });
            }
        };

        /**
         * Adds the audit tab to the conversation page, then loads the template, along with the appropriate view
         * It also adds the css along with the label to the Audit Tab
         * @returns void
         */
        var addAuditTab = function(){
            if (qualityAuthorization.canViewAnyAudit()){
                if (!self.tabbedDetails.containsTab('audit')){
                    var tabContentViews = {};
                    tabContentViews.audit = {
                        view: AuditView,
                        template: "templates/appMain/privilegedMain/qm/auditView",
                        arguments: self.conversationId(),
                        persist: true
                    };
                    var tabMenuItems = getTabMenuItems("admin", self.conversationId(), 'audit', 'audit');
                    self.tabbedDetails.addTabViews(tabMenuItems, tabContentViews);
                }
            }
        };

        /**
         * Activates the audit tab. This is getting called by qm-routes.
         */
        self.activateAuditTab = function(){
            addAuditTab();
            self.tabbedDetails.setActiveTabView('audit');
        };

        /**
         * Activates the conversation timeline tab. This is getting called by qm-routes.
         */
        self.activateTimelineTab = function(){
            addTimelineTab();
            self.tabbedDetails.setActiveTabView('timeline');
        };

        var deleteCalibrationCallback = function(calibrationId) {
            if(qualityAuthorization.canDeleteCalibration()) {
                qualityManagementService.deleteCalibration(calibrationId)
                    .then(function() {
                        self.tabbedDetails.removeActiveTabView();
                        toasts.notifyMessage('playback.nav.calibration.deleted.title', {
                            bodyMessageKey: 'playback.nav.calibration.deleted.msg'
                        });
                    })
                    .catch(function() {
                        toasts.notifyMinorAlert('playback.nav.calibration.not.deleted.title', {
                            bodyMessageKey: 'playback.nav.calibration.not.deleted.msg'
                        });
                    });
            }
        };

        function removeEvaluationTab(context, assignedEvaluationId, activateTabKey) {
            var tabMenuItems = getTabMenuItems(context, self.conversationId(), 'evaluations/' + assignedEvaluationId, 'evaluation');

            if (self.tabbedDetails.containsTabAndHash(assignedEvaluationId, tabMenuItems[0].hash)) {
                self.tabbedDetails.removeTabView(assignedEvaluationId, tabMenuItems[0].hash);
                if (!_.isUndefined(activateTabKey)) { // allow null
                    self.tabbedDetails.setActiveTabView(activateTabKey);
                }
            }
        }

        var addAssignedEvaluationTab = function (assignedEvaluationId, isAdminContext) {

            if (!qualityAuthorization.canViewEvaluation()) {
                return;
            }

            var context = "agent", otherContext="admin";
            if (isAdminContext && self.canEditEvaluationOrScore) {
                context = "admin";
                otherContext = "agent";
            }

            removeEvaluationTab(otherContext, assignedEvaluationId, null);

            if (!self.tabbedDetails.containsTab(assignedEvaluationId)) {
                var tabContentViews = {};
                tabContentViews[assignedEvaluationId] = {
                    view: EvaluationViewWrapper,
                    template: "templates/appMain/privilegedMain/qm/evaluation",
                    arguments: [ self.conversationId(), assignedEvaluationId, isAdminContext, deleteEvaluationCallback ],
                    persist: true
                };

                var tabMenuItems = getTabMenuItems(context, self.conversationId(), 'evaluations/' + assignedEvaluationId, 'evaluation');
                self.tabbedDetails.addTabViews(tabMenuItems, tabContentViews);
            }
        };

        self.activateAssignedEvaluationTab = function (assignedEvaluationId, isAdminContext) {
            qualityBroadcast.publish(self.conversationId(), BroadcastEnum.ACTIVATED_EVALUATION + assignedEvaluationId, {activate: true});
            addAssignedEvaluationTab(assignedEvaluationId, isAdminContext);
            return activateTabIfNeeded(assignedEvaluationId, self.conversationId(), assignedEvaluationId, isAdminContext, deleteEvaluationCallback);
        };

        var addCalibrationTab = function (calibrationId) {
            if (qualityAuthorization.canViewCalibration()){
                if (!self.tabbedDetails.containsTab(calibrationId)) {
                    var tabContentViews = {};
                    tabContentViews[calibrationId] = {
                        view: CalibrationResultsView,
                        template: "templates/appMain/privilegedMain/qm/calibrationResults",
                        arguments: [ calibrationId, deleteCalibrationCallback ],
                        persist: true
                    };
                    var tabMenuItems = getTabMenuItems('admin', self.conversationId(), 'calibrations/' + calibrationId, 'calibration');
                    self.tabbedDetails.addTabViews(tabMenuItems, tabContentViews);
                }
            }
        };

        self.activateCalibrationTab = function (calibrationId) {
            addCalibrationTab(calibrationId);
            self.tabbedDetails.setActiveTabView(calibrationId, calibrationId, deleteCalibrationCallback);
        };

        var addSurveyTab = function (surveyId) {
            if (qualityAuthorization.canViewSurvey()) {
                if (!self.tabbedDetails.containsTab(surveyId)) {
                    var tabContentViews = {};
                    tabContentViews[surveyId] = {
                        view: EmbeddedQualityFormEditor,
                        arguments: [FormType.survey, null, surveyId],
                        template: 'templates/appMain/privilegedMain/composer/forms/embeddedQualityFormEditor',
                        classNames: { 'details-tab-content-no-padding': true },
                        persist: true,
                        persistDOM: true
                    };

                    var tabMenuItems = getTabMenuItems('admin', self.conversationId(), 'surveys/' + surveyId, 'survey');
                    self.tabbedDetails.addTabViews(tabMenuItems, tabContentViews);
                }
            }
        };

        self.activateSurveyTab = function (surveyId) {
            addSurveyTab(surveyId);
            return self.tabbedDetails.setActiveTabView(surveyId);
        };

        var addQualitySummaryTab = function () {
            if(qualityAuthorization.canAddEvaluation() ||
                qualityAuthorization.canDeleteEvaluation() ||
                qualityAuthorization.canAddCalibration() ||
                qualityAuthorization.canViewSurvey()) {
                if(!self.tabbedDetails.containsTab('qualitySummaryView')) {
                    var tabContentViews = {
                        'qualitySummaryView': {
                            view: QualitySummaryView,
                            template: "templates/appMain/privilegedMain/qm/qualitySummary",
                            arguments: [self.conversationId, self.hasParticipantToEvaluate, deleteEvaluationCallback],
                            persist: true
                        }
                    };
                    var tabMenuItems = getTabMenuItems('admin', self.conversationId(), 'qualitySummary', 'qualitySummary');
                    self.tabbedDetails.addTabViews(tabMenuItems, tabContentViews);
                }
            }
        };

        self.activateQualitySummaryTab = function() {
            addQualitySummaryTab();
            activateTabIfNeeded('qualitySummaryView');
        };

        var addCustomerJourneyTab = _.once(function(journeyContexts, activeJourneyCustomerSessionId) {
            if (!self.canViewConversationCustomerJourney) {
                return Bluebird.reject(new InsufficientPermissionsError(CUSTOMER_JOURNEY_PERMISSIONS));
            }

            if (!journeyContexts || _.isEmpty(journeyContexts)) {
                return Bluebird.reject(new MissingJourneyContextError());
            }

            var tabContentViews = {};
            tabContentViews.journeys = {
                view: CustomerJourneyView,
                arguments: [journeyContexts, activeJourneyCustomerSessionId],
                template: 'templates/appMain/privilegedMain/qm/customerJourney',
                persist: true
            };
            var tabMenuItems = getTabMenuItems('admin', self.conversationId(), 'journeys', 'journeys');
            self.tabbedDetails.addTabViews(tabMenuItems, tabContentViews); 
            return Bluebird.resolve();  
        });

        var redirectToDetails = function () {
            return navHelper.redirectTo('#/' + getHashContext() + '/interactions/' + self.conversationId());
        };

        self.activateCustomerJourneyTab = function(sessionId) {
            return new Bluebird(function(resolve) {
                var conversationDetailsV6 = self.conversationDetailsV6();
                if (conversationDetailsV6) {
                    // if we already have a conversation, use that
                    resolve(conversationDetailsV6);
                } else {
                    // if called from the route handler, the conversation will not yet be available.
                    // setting up a self-disposing subscription handles this case
                    var convSubs = self.subscribe(self.conversationDetailsV6, function (nextConversation) {
                        if (nextConversation) {
                            convSubs.dispose();
                            resolve(nextConversation);
                        }
                    });
                }
            }).then(function(conversationDetailsV6) {
                var conversationJourneyContexts = getConversationCustomerParticipantJourneyContexts(conversationDetailsV6);
                return addCustomerJourneyTab(conversationJourneyContexts, sessionId);
            }).then(function() {
                activateTabIfNeeded('journeys');
            }).catch(
                InsufficientPermissionsError,
                FeatureToggleDisabledError,
                MissingJourneyContextError,
                function(err) {
                    if (err instanceof InsufficientPermissionsError) {
                        toastService.notifyMajorAlert('', {
                            bodyMessage: 'config.error.forbidden'
                        });
                    }
                    return redirectToDetails();
                }
            );
        };

        /**
         * SUBSCRIPTIONS
         */

        self.subscribe(self.conversation, function(nextConversation) {
            if(nextConversation) {
                self.hasParticipantToEvaluate(checkInternalParticipant(nextConversation.participants));
                self.needsWrapup(checkIfNeedsWrapup(nextConversation.participants));
                self.acdVoicemailIds(getAcdVoicemailIds(nextConversation));

                self.isCurrentUserOnConversation(_.some(nextConversation.participants(), function (participant) {
                    return userService.currentUser() &&
                        userService.currentUser().id &&
                        userService.currentUser().id === participant.userId;
                }));
            }
        });

        self.subscribe(self.conversationId, function(){
            getConversation();
            getConversationDetailsV6();

            getEvaluations();

            if (qualityAuthorization.canViewCalibration()){
                getCalibrations();
            }

            addConversationTab(self.conversationId());
            addTimelineTab(self.conversationId());
            addQualitySummaryTab();
            if (qualityAuthorization.canViewAnyAudit()){
                addAuditTab();
            }
        });

        //add the conversation details
        addConversationTab(self.conversationId());
        addTimelineTab(self.conversationId());

        addQualitySummaryTab();

        if (qualityAuthorization.canViewAnyAudit()){
            addAuditTab();
        }

        addTimelineTab();

        self.subscribe(self.evaluations, function(newVal) {
            _.each(newVal.entities(), function(evaluation) {
                addAssignedEvaluationTab(evaluation.id, getHashContext() === "admin");
            });
        });

        self.subscribe(self.calibrations, function(newVal) {
            _.each(newVal.entities, function(calibration) {
                addCalibrationTab(calibration.id);
            });
        });

        self.subscribe(self.journeyContexts, function(journeyContexts) {
            var hasJourneysTab = self.tabbedDetails.containsTab('journeys');
            if (!hasJourneysTab) {
                addCustomerJourneyTab(journeyContexts)
                    .catch(
                        InsufficientPermissionsError,
                        MissingJourneyContextError,
                        _.noop
                    );
            }
        });

        /**
         * CLEAN UP
         */
        self.onDispose = function () {
            clearInterval(activeConversationUpdateInterval);
        };
    });

    return PlaybackView;
});

